import axios from '../../localAxios';
import { MoveTask } from '../MoveTask';
import { moveURL } from '../url';

export interface MoveQuizFolderParam {
  folderIds?: number[];
  quizIds?: number[];
  parentId: number;
}

export type MoveQuizFolderResponse = Record<string, never>;

export async function moveQuizFolder({
  folderIds = [],
  quizIds = [],
  parentId,
}: MoveQuizFolderParam) {
  const url = moveURL();
  const response = await axios.put<MoveQuizFolderResponse>(url.href, {
    folderIds: folderIds,
    parentId: parentId,
    quizIds: quizIds,
    task: MoveTask.MOVE,
  });
  return response.data;
}
